import React from "react";
import { GoLocation } from "react-icons/go";

const OppComponent = ({
  opportunity,
  index,
  openModal,
  setSelectedOpportunity,
}) => {
  return (
    <>
      <div
        onClick={() => {
          openModal();
          setSelectedOpportunity(opportunity);
        }}
      >
        <div class="block max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
          <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            {opportunity?.jobTitle}
          </h5>
          <div className="text-[10px] text-white sm:text-[16px] font-[500] pb-2 h-[20%]">
            {opportunity?.jobType}
          </div>
          <p class="font-normal text-gray-700 dark:text-gray-400 pb-2 ">
            {opportunity?.jobDescription}
          </p>
          <div className="text-[10px] sm:text-[14px] font-[500] text-white  flex items-center h-[20%]">
            <GoLocation className="text-[24px] pr-1 " />{" "}
            {opportunity?.jobLocation}
          </div>
        </div>
        {/* <div className=" sm:text-[18px] text-[14px] font-[600] pb-3 h-[20%] truncate">
          {opportunity?.jobTitle}
        </div>
        <div className="text-[10px] sm:text-[16px] font-[500] pb-3 h-[20%]">
          {opportunity?.jobType}
        </div>

        <div className="text-[10px] sm:text-[14px] font-[500] pb-3 text-[#6c6c89] h-[40%] truncate">
          {opportunity?.jobDescription}
        </div>
        <div className="text-[10px] sm:text-[14px] font-[500]  flex items-center h-[20%]">
          <GrMapLocation className="text-[24px] pr-1" />{" "}
          {opportunity?.jobLocation}
        </div> */}
      </div>
    </>
  );
};

export default OppComponent;
